import React from 'react';
import {MenuItem} from '@techsmith/tsc-cloud-style-guide';
import {useTranslation} from 'react-i18next';
import EyeOnGlyph16x16 from '../../static/svg/EyeOnGlyph16x16.svg';
import EyeOffGlyph16x16 from '../../static/svg/EyeOffGlyph16x16.svg';

const ResolveToggleBase: React.FC<IResolveToggleProps> = ({isHidingResolvedComments, toggleResolvedComments}) => {
   const {t} = useTranslation();

   return (
      <MenuItem
         label={isHidingResolvedComments ? t('conversations.showResolved') : t('conversations.hideResolved')}
         glyph={isHidingResolvedComments ? <EyeOnGlyph16x16 /> : <EyeOffGlyph16x16 />}
         onClick={toggleResolvedComments}
         testId="toggle-resolved-comments"
      />
   );
};

export interface IResolveToggleProps {
   isHidingResolvedComments: boolean;
   toggleResolvedComments(): void;
}

export default ResolveToggleBase;
